import React from 'react'
import { inject, observer } from 'mobx-react'

import { CustomSelect     } from '../../components/select'

export const PartnerSelector = inject('partnersStore')(observer(({partnersStore,...props}) =>
<CustomSelect {...props}
  options={partnersStore.options}
/>))
